// extracted by mini-css-extract-plugin
module.exports = {"container":"setting_container__3ZoHE","info":"setting_info__MCXpF","adm-card-body":"setting_adm-card-body__1s3YL","centerImg":"setting_centerImg__1uwgI"};